// Prev/next pagination for admin lists ({items,total,limit,offset} envelope).
// Upstream: cosscom/coss apps/origin/registry/default/components/comp-454.tsx — MIT (range text + prev/next).

import { Glyph } from "@/ui";
import { Button } from "@/ui";

export interface PaginationProps {
  total: number;
  limit: number;
  offset: number;
  onPage: (offset: number) => void;
  /** Disable while the surrounding list is loading. */
  disabled?: boolean;
}

export function Pagination({ total, limit, offset, onPage, disabled = false }: PaginationProps) {
  if (total <= 0 || total <= limit) return null;

  const from = offset + 1;
  const to = Math.min(offset + limit, total);
  const prevOffset = Math.max(0, offset - limit);
  const hasPrev = offset > 0;
  const hasNext = offset + limit < total;

  return (
    <div data-slot="pagination" className="flex flex-wrap items-center justify-between gap-3">
      <span className="text-sm text-fg-2 tabular-nums">
        {from}–{to} dari {total}
      </span>
      <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="quiet"
          size="sm"
          onClick={() => onPage(prevOffset)}
          disabled={disabled || !hasPrev}
        >
          <Glyph name="chevronLeft" />
          Sebelumnya
        </Button>
        <Button
          variant="quiet"
          size="sm"
          onClick={() => onPage(offset + limit)}
          disabled={disabled || !hasNext}
        >
          Berikutnya
          <Glyph name="chevronRight" />
        </Button>
      </div>
    </div>
  );
}
